import { CheckOutlined, ExpandOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface NotificationsPopoverHeaderProps {
  unreadCount: number
  onMarkAllAsRead: () => void
  onExpand: () => void
  disabled?: boolean
}

export function NotificationsPopoverHeader({
  unreadCount,
  onMarkAllAsRead,
  onExpand,
  disabled = false
}: NotificationsPopoverHeaderProps) {
  const { t } = useTranslation()

  return (
    <Flex justify="space-between" align="center">
      <Text strong>
        {t("notifications.bell.title", { n: unreadCount })}
      </Text>
      <Flex gap={8} align="center">
        {disabled && (
          <Text type="secondary" className="text-xs">
            {t("notifications.bell.offline")}
          </Text>
        )}
        {unreadCount > 0 && (
          <Button
            type="link"
            size="small"
            icon={<CheckOutlined />}
            className="p-0 h-auto text-xs"
            onClick={onMarkAllAsRead}
            disabled={disabled}
          >
            {t("notifications.bell.markAllRead")}
          </Button>
        )}
        <Button
          type="text"
          size="small"
          icon={<ExpandOutlined aria-hidden />}
          className="p-0 h-auto text-xs"
          onClick={onExpand}
        >
          {t("notifications.bell.viewAll")}
        </Button>
      </Flex>
    </Flex>
  )
}
